module.exports = function(service) {
	'use strict'
	service.service('serverError',serverError);
	serverError.$inject=['$rootScope','$interval','$window'];
	function serverError($rootScope,$interval,$window) {
		var serverErrorInterval;
		return function() {
			if(!$rootScope.serverError.show) {
				$rootScope.serverError={
					'show': true,
					'i': 10
				}
				serverErrorInterval = $interval(function() {
					if($rootScope.serverError.i==0) {
						$interval.cancel(serverErrorInterval);
						$window.location.reload();
						return
					}
					$rootScope.serverError.i--;	
				},1000);
				$rootScope.retry = function() {
					$interval.cancel(serverErrorInterval);
					$window.location.reload();
				}
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/serverErrorService.js
// module id = 626
// module chunks = 0